import { Classes, Colors } from '@pinpointhq/thumbtack';
import * as React from 'react';

interface IDrawerFooterProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isStd?: boolean;
}

/**
 * @deprecated Please use the Thumbtack version of this component
 * If it does not cover your use case please speak to Tom Luce
 */
export function DrawerFooter(props: IDrawerFooterProps) {
  const { isStd = false, className, style, ...rest } = props;

  if (isStd) {
    // @NOTE: (Leo Melo) we want to extract the children from the rest props so we can add it next to the
    // React version of our`:before` element
    const { children, ...otherRest } = rest;
    return (
      <div
        data-testid="drawer-footer"
        className={`${className || ''}`}
        style={{
          borderTop: `1px solid ${Colors.IVORY_20}`,
          boxShadow: 'none',
          margin: 0,
          padding: '24px 40px',
          ...style,
        }}
        {...otherRest}
      >
        {/* Work around for the lack of `Classes.DRAWER_FOOTER` which adds a :before element */}
        <div
          style={{
            position: 'absolute',
            top: '-40px',
            bottom: '100%',
            width: '100%',
          }}
        />
        {children}
      </div>
    );
  }

  /**
   * I made some styling changes in Thumbtack that removed the margin entirely
   * I also added the `DrawerFooter` component to Thumbtack - that should now now be used in place of this
   * To ensure backwards compatibility we need to apply the old styles here,
   * although I have decided to not re-add the box shadow.
   */
  const styles = { margin: '40px', padding: '24px 0 0 0', ...style };

  return <div className={`${className || ''} ${Classes.DRAWER_FOOTER}`} style={styles} {...rest} />;
}
